<template>
  <router-view />
  <!-- The templates open full screen over whatever page this is when the address asks for it (?templates=1 or ?template=lumen). Loaded only then. -->
  <TemplatesPanel v-if="templatesOpen" />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'

const TemplatesPanel = defineAsyncComponent(() => import('controllers/vue_components/events/design/TemplatesPanel.vue'))
const route = useRoute()
const templatesOpen = computed(() => route.query.templates !== undefined || route.query.template !== undefined)
</script>
